import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllEmployeeWorkTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmployeeWorkType}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getEmployeeWorkTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmployeeWorkType}?CompanyCode=${companyCode}&Code=${code}` // 
  );
  return data;
};

const insertEmployeeWorkType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.EmployeeWorkType, input);
  return data;
};

const updateEmployeeWorkType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.EmployeeWorkType, input);
  return data;
};

const deleteEmployeeWorkType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.EmployeeWorkType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetEmployeeWorkTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmployeeWorkType],
    queryFn: () => getAllEmployeeWorkTypes(input),
     refetchOnWindowFocus: false,
    
  });
};

export const useGetEmployeeWorkTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmployeeWorkType],
    queryFn: () => getEmployeeWorkTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertEmployeeWorkTypeMutation = () => {
  return useMutation({
    mutationFn: insertEmployeeWorkType,
  });
};

export const useUpdateEmployeeWorkTypeMutation = () => {
  return useMutation({
    mutationFn: updateEmployeeWorkType,
  });
};

export const useDeleteEmployeeWorkTypeMutation = () => {
  return useMutation({
    mutationFn: deleteEmployeeWorkType,
  });
};
